export const raidPlanBaseUrl = 'https://raidstrats.gg/planner?view='

export const extractUuid = (value: string) => {
  const match = value.match(
    /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i,
  )
  return match?.[0] ?? null
}

export const getRaidPlanLinkInfo = (link?: string) => {
  const value = (link ?? '').trim()
  const extractedRaidPlanId = extractUuid(value)
  const raidPlanId = extractedRaidPlanId ?? value
  return {
    raidPlanId,
    extractedRaidPlanId,
    url: `${raidPlanBaseUrl}${raidPlanId}`,
    hasRaidPlanId: Boolean(raidPlanId),
    hasValidRaidPlanId: Boolean(extractedRaidPlanId),
  }
}
